import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

type Props = {
    // Names what goes, since the icon alone does not say.
    label: string;
    onClick: () => void;

    // Set where a spec or the Angular form addressed the button by name.
    name?: string;

    // Set when the row may not go, as a chapter holding an assessment may not while assessment
    // editing is locked.
    disabled?: boolean;
};

/*
    Takes one row out of a list.

    Flush against the controls beside it, so a row's icons read as one cluster wherever they appear.
*/
export default function RemoveButton({ label, onClick, name, disabled = false }: Props) {
    return (
        <IconButton name={name} aria-label={label} size="small" disabled={disabled} onClick={onClick}>
            <Close fontSize="small" />
        </IconButton>
    );
}
